<template>
  <a
    href="javascript:void(0);"
    class="text-primary text-decoration-none"
    data-testid="so-address-map-address"
    @click.prevent="openDialog"
  >
    {{ address }}
  </a>

  <SoDialog
    v-model="isDialogOpen"
    :card-title="address"
    :loading="isLocatingAddress"
  >
    <slot></slot>

    <div class="so-address-map__map" data-testid="so-address-map-map">
      <SoMap v-if="addressLatLng && !error" :location="addressLatLng" />
      <div
        v-else-if="error === MapGeocoderStatus.INVALID_ADDRESS"
        class="text-center ma-auto"
        data-testid="so-address-map-error-invalid"
      >
        <v-icon icon="map-marker-question" size="x-large"></v-icon>
        <p class="mt-5">Could not find the address</p>
      </div>
      <div
        v-else-if="error"
        class="text-center ma-auto"
        data-testid="so-address-map-error"
      >
        <v-icon icon="close-circle" size="x-large"></v-icon>
        <p class="mt-5">
          Error: Something went wrong with geocoding the address
        </p>
      </div>
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoMap from "@/components/SoMap.vue"
  import { MapLatLng, MapGeocoderStatus } from "@/types/Map"
  import { MapService } from "@/services/MapService"

  export default defineComponent({
    components: {
      SoDialog,
      SoMap,
    },

    props: {
      address: {
        type: String,
        default: "",
      },
    },

    data() {
      return {
        MapGeocoderStatus,
        isDialogOpen: false,
        isLocatingAddress: false,
        addressHasChanged: false,
        addressLatLng: null as MapLatLng | null | undefined,
        mapService: null as MapService | null,
        error: "",
      }
    },
    watch: {
      address() {
        this.addressHasChanged = true
      },
    },
    methods: {
      async openDialog() {
        this.isDialogOpen = true
        if (!this.addressLatLng || this.addressHasChanged) {
          await this.locateAddress(this.address)
        }
      },

      async locateAddress(address: string) {
        this.isLocatingAddress = true
        this.addressLatLng = null
        this.error = ""

        if (!this.mapService) {
          this.mapService = new MapService()
        }

        try {
          this.addressLatLng = await this.mapService.geocodeAddress(address)
          this.addressHasChanged = false
        } catch (error) {
          console.error(error)
          this.error = error?.toString() || "Something went wrong"
        }
        this.isLocatingAddress = false
      },
    },
  })
</script>

<style>
  .so-address-map__map {
    display: flex;
    height: 450px;
    background-color: rgb(var(--v-theme-background));
  }
</style>
